<template lang="pug">
  div.wrap-module-user
    div.user-content
      div.wrap-profile.py16.f.fm
        div.wrap-icon.mr16
          v-avatar(size="64px")
            v-img(:src="user.iconPhotoURL")
        div.about
          div.f.fm
            span.fz16.bold.block.mr8 {{user.name}}
            v-icon(v-if="$route.name == 'mypage'"
              @click="$router.push('/edit-profile')" size="20px").mr4 mdi-pencil
            v-icon(@click="$router.push('/others')" size="20px") mdi-settings
          span.fz14 {{user.profile}}
      div.wrap-slide.pt16.pb40
        div.f.fm.flex-between.mb24
          span.fz22.bold Slides
          div(v-if="$route.name == 'mypage'"
            @click="$router.push('/add-slide')").btn-add.cursor-pointer.f.fm.px10.py6
            v-icon(size="20px").mr6 mdi-credit-card-plus-outline
            span.bold.fz12 Add your Slide
        div.slides-list
          div(v-if="slides[0]").wrap-slides
            div(v-for="slide in slides").mb22
              ItemUserSlideCard(:key="slide.id" :slide="slide")
          div(v-else).wrap-no-slide.f.fh
            div(v-if="$route.name == 'mypage'")
              span.block.text-center.fz14.mb4 There is no slide.
              span.block.text-center.fz14.mb20  Let's upload your First slide!
              div.cursor-pointer.f.fc
                span(@click="$router.push('/add-slide')").btn-add.px18.py6 Add First Slide
            div(v-else)
              span.block.text-center.fz14 No slide
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-user {
  width: 100%;
  min-height: 100vh;
  padding-top: $header_height;
  .user-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-profile {
      border-bottom: $basic_border;
    }
    .wrap-slide {
      position: relative;
      .btn-add {
        background: $active_color;
        border-radius: 3px;
      }
      .wrap-no-slide {
        height: 50vh;
      }
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import ItemUserSlideCard from '@/components/item/ItemUserSlideCard'

export default {
  components: {
    ItemUserSlideCard
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    slides: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      
    }
  }
}
</script>
